/* eslint-disable global-require */
module.exports = [...require('./StripeCheckoutForm/i18n'), 'payments.platforms.stripe.m1'];
